import {create} from 'zustand';

export type CaptureMode = 'intro' | 'camera' | 'crop' | 'denied';

type CaptureModeStore = {
  mode: CaptureMode;
  setMode: (mode: CaptureMode) => void;
};

export const useCaptureModeStore = create<CaptureModeStore>(set => ({
  mode: 'camera',
  setMode: mode => set({mode}),
}));
